<template>
    <div class="wrapper">
        <NavBar />
        <Menu />
        <!-- Spinner Start -->
        <div id="spinner" v-if="halamanloading"
            class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
            style="opacity: 0.5;">
            <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <!-- Spinner End -->
        <div class="content-wrapper py-3">
            <div class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6 wow fadeInDown">
                            <h5>Program & Budgeting</h5>
                        </div>
                        <div class="col-sm-6 wow fadeInDown">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item"><a href="/Dashboard">Home </a></li>
                                <li class="breadcrumb-item active">Pengaturan Program & Budgeting</li>
                            </ol>
                        </div>
                    </div><!-- /.row -->
                </div><!-- /.container-fluid -->
            </div>
            <!-- /.content-header -->
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-sm-12 wow fadeInDown">
                            <div class="card cardputih">
                                <div class="card-header border-transparent">
                                    <div class="col-sm-11 float-left pb-2" v-if="leveluser != 9">
                                        <input type="text" v-model="carikata" class="form-control form-control-sm"
                                            placeholder="Masukkan Kata Kunci Pencarian">
                                    </div>
                                    <div class="col-sm-11 float-left pb-2" v-if="leveluser == 9">
                                        <input type="text" v-model="carikata" class="form-control form-control-sm"
                                            placeholder="Masukkan Kata Kunci Pencarian">
                                    </div>
                                    <div class="card-tools">
                                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                            <i class="fas fa-minus"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="card-body p-0">
                                    <div class="table-responsive table-wrapper">
                                        <table class="table m-0" id="tabeldata" style="font-size: 11px;">
                                            <thead>
                                                <tr>
                                                    <th style="width: 50px;" rowspan="3">No</th>
                                                    <th style="width: 150px;" rowspan="3">Opsi</th>
                                                    <th style="width: 150px;" rowspan="3">Satker</th>
                                                    <th style="width: 350px;" rowspan="3">Nama Kegiatan</th>
                                                    <th style="width: 150px;" rowspan="3">Kategori</th>
                                                    <th style="width: 150px;" colspan="3">OWP</th>
                                                    <th style="width: 350px;" :colspan="colspan * 3">AWP</th>
                                                    <th style="width: 350px;" :colspan="colspan * 3">Disbursement Plan
                                                    </th>
                                                    <th style="width: 150px;" rowspan="3">Dibuat Oleh</th>
                                                </tr>
                                                <tr>
                                                    <th style="width: 50px;" rowspan="2">IDR</th>
                                                    <th style="width: 50px;" rowspan="2">USD</th>
                                                    <th style="width: 50px;" rowspan="2">JPY</th>
                                                    <template v-for="(datatahun, uruttahun) in datatahun"
                                                        :key="uruttahun">
                                                        <th style="width: 50px;" colspan="3">{{ datatahun }}</th>
                                                    </template>
                                                    <template v-for="(datatahun, uruttahun) in datatahun"
                                                        :key="uruttahun">
                                                        <th style="width: 50px;" colspan="3">{{ datatahun }}</th>
                                                    </template>
                                                </tr>
                                                <tr>
                                                    <template v-for="(datatahun, uruttahun) in datatahun"
                                                        :key="uruttahun">
                                                        <th style="width: 50px;">IDR</th>
                                                        <th style="width: 50px;">USD</th>
                                                        <th style="width: 50px;">JPY</th>
                                                        <th style="width: 50px;">IDR</th>
                                                        <th style="width: 50px;">USD</th>
                                                        <th style="width: 50px;">JPY</th>
                                                    </template>
                                                </tr>
                                            </thead>
                                            <template v-for="(datalist, urutlist) in filteredKataData" :key="urutlist">
                                                <tbody>
                                                    <tr>
                                                        <td :class="datalist.classcek + ' text-center'">
                                                            {{ urutlist + 1 }}
                                                        </td>
                                                        <td :class="datalist.classcek + ' text-center'">
                                                            <button type="button" v-if="leveluser != 9"
                                                                class="btn btn-primary3 btn-sm text-white" style="font-size: 11px;"
                                                                @click="prosesdata(datalist.id)" data-toggle="tooltip"
                                                                data-placement="left" title="Edit data.."><i
                                                                    class="fas fa-edit"></i> Edit Data</button>
                                                            <button type="button" v-if="leveluser == 9"
                                                                class="btn btn-primary3 btn-sm text-white" style="font-size: 11px;"
                                                                @click="prosesdata(datalist.id)" data-toggle="tooltip"
                                                                data-placement="left" title="Lihat data.."><i
                                                                    class="far fa-eye"></i> Lihat Data</button>
                                                        </td>
                                                        <td :class="datalist.classcek">
                                                            {{ datalist.kode_satker }} - 
                                                            {{ datalist.nama_satker }}
                                                        </td>
                                                        <td :class="datalist.classcek">
                                                            {{ datalist.Nama_Kegiatan }}
                                                        </td>
                                                        <td :class="datalist.classcek">
                                                            {{ datalist.Kategori }}
                                                        </td>
                                                        <td :class="datalist.classcek + ' text-right'">
                                                            {{ G_numFormat(datalist.NilaiOWP) }}
                                                        </td>
                                                        <td :class="datalist.classcek + ' text-right'">
                                                            {{ G_numFormat(datalist.NilaiOWP_usd) }}
                                                        </td>
                                                        <td :class="datalist.classcek + ' text-right'">
                                                            {{ G_numFormat(datalist.NilaiOWP_lain) }}
                                                        </td>
                                                        <template
                                                            v-for="(dataNilaiAWP, urutNilaiAWP) in datalist.NilaiAWP"
                                                            :key="urutNilaiAWP">
                                                            <td :class="datalist.classcek + ' text-right'">
                                                                {{ G_numFormat(dataNilaiAWP.Nilai) }}
                                                            </td>
                                                            <td :class="datalist.classcek + ' text-right'">
                                                                {{ G_numFormat(dataNilaiAWP.Nilai_usd) }}
                                                            </td>
                                                            <td :class="datalist.classcek + ' text-right'">
                                                                {{ G_numFormat(dataNilaiAWP.Nilai_lain) }}
                                                            </td>
                                                        </template>
                                                        <template
                                                            v-for="(dataDISBURSEMENT, urutDISBURSEMENT) in datalist.DISBURSEMENT"
                                                            :key="urutDISBURSEMENTP">
                                                            <td :class="datalist.classcek + ' text-right'">
                                                                {{ G_numFormat(dataDISBURSEMENT.Nilai) }}
                                                            </td>
                                                            <td :class="datalist.classcek + ' text-right'">
                                                                {{ G_numFormat(dataDISBURSEMENT.Nilai_usd) }}
                                                            </td>
                                                            <td :class="datalist.classcek + ' text-right'">
                                                                {{ G_numFormat(dataDISBURSEMENT.Nilai_lain) }}
                                                            </td>
                                                        </template>
                                                        <td :class="datalist.classcek">
                                                            {{ datalist.dibuatoleh }}, {{
                                                                G_formatDate(datalist.createddate) }}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                            <tbody v-if="(datapesan == 'data kosong')">
                                                <tr>
                                                    <td colspan="5">Data masih kosong</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="card-footer p-3">

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
import $ from 'jquery';
import axios from 'axios';
import vSelect from 'vue-select';
import swal from 'sweetalert2';
import CryptoJS from 'crypto-js';
import Footer from "../../componen/Footer.vue";
import NavBar from "../../componen/NavBar.vue";
import Menu from "../../componen/Menu.vue";

import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "Poppins-SemiBold, Arial, sans-serif" };
export default {
    components: {
        Footer, NavBar, Menu, vSelect, swal
    },
    data() {
        return {
            halamanloading: true,
            iduser: JSON.parse(localStorage.getItem("usistem")),
            leveluser: JSON.parse(localStorage.getItem("lsistem")),
            namauser: JSON.parse(localStorage.getItem("nmusistem")),
            levelinstansi: JSON.parse(localStorage.getItem("inssistem")),
            datapesan: '',
            datamaster: [],
            carikata: '',
            folder_foto: process.env.VUE_APP_URL_API + 'parastapainnovation_slider-Gambar?f=',
            project_id: process.env.VUE_APP_PROJECT_ID,
            colspan: 0,
            datatahun: [],
        }
    },
    computed: {
        filteredKataData() {
            const filteredWorkers = this.carikata === ""
                ? this.datamaster
                : this.datamaster.filter(wo => Object.values(wo).join("").toLowerCase().indexOf(this.carikata.toLowerCase()) !== -1);
            return filteredWorkers;
        },
        JumlahfilteredKataData() {
            var jumlah = 0;
            try {
                if (this.filteredKataData === undefined) {
                    jumlah = 0;
                } else {
                    jumlah = this.filteredKataData.length;
                }
            }
            catch {
                jumlah = 0;
            }
            return jumlah;
        },
    },
    methods: {
        getOtentifikasi() {
            var time = Date.parse(localStorage.getItem("tsistem"));
            var timeakhir = time + (3 * 60 * 60 * 1000);
            var timesekarang = Date.parse(new Date());
            if (timesekarang > timeakhir) {
                this.ClearlocalStorage();
            }
        },
        async ambildata() {
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            await mainAPI.get("parastapainnovation_program-GetData?random=" + random + "&project_id=" + this.project_id + "&id_user=" + this.levelinstansi).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.datamaster = [];
                        this.datatahun = [];
                        this.colspan = 0;
                        this.datamaster = Response.data.content.data;
                        this.datatahun = Response.data.tahun;
                        this.colspan = Response.data.jumlahtahun;
                        this.halamanloading = false;
                    }
                    else {
                        this.datamaster = [];
                        this.datatahun = [];
                        this.colspan = 0;
                        this.halamanloading = false;
                    }

                }
            ).catch(error => {
                console.log(error);
                this.datamaster = [];
                this.ClearlocalStorage();
                this.halamanloading = false;
            });
        },
        prosesdata(kode) {
            var bytes = encodeURIComponent(CryptoJS.AES.encrypt(kode, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
            window.location.replace("/ProsesProgram/" + bytes);
        },
    },
    mounted() {
        this.getOtentifikasi();
        this.ambildata();
    }
}
</script>
<style></style>